import { useEffect } from 'react';

/**
 * Add this to the body of components that you want to hide the intercom launcher
 * while the component is mounted. (IE drawers that cover up the corner)
 */
export function useHideIntercomOnMount() {
  useEffect(() => {
    // Don't touch the launcher if it's supposed to be hidden
    if (window.intercomSettings?.hide_default_launcher) {
      return () => {
        /* noop */
      };
    }

    window['Intercom']?.('update', {
      hide_default_launcher: true,
    });
    return () =>
      window['Intercom']?.('update', {
        hide_default_launcher: false,
      });
  }, []);
}

/**
 * Instead of calling the hook, you can include this component in your tree
 * this will hide the IntercomLauncher when this component renders.
 * When this component unmounts the intercom launcher will appear again.
 */
export function HideIntercomLauncher() {
  useHideIntercomOnMount();
  return null;
}
